import { ICONS, preloadSvgAssets, replaceConversationCircleSVGs, replaceMiniPanelSVGs } from "./svg/assets.js";

(async () => {
  const locId = window.location.pathname.split("/")[3];
  if (!locId) return;

  const cookie = await cookieStore.get(`gstier:::${locId}`);
  if (!cookie || !cookie.value) return;

  const tier = cookie.value;
  document.body.classList.add("gstier-active");

  console.log("[GHL Build] Theme JS loaded");

  window.GHLTheme = {
    version: "0.1.0",
    scopeSelector: "._LCksl7nZ6vXELfyfu32G"
  };

  preloadSvgAssets();

  function installGhlSpaNavigationBridge() {
    if (window.__ghlThemeSpaNavigationBridgeInstalled) return;
    window.__ghlThemeSpaNavigationBridgeInstalled = true;

    const CUSTOM_NAV_SELECTOR = 'a[data-ghl-spa-link="true"]';

    const normalizeUrlPath = value => {
      try {
        const url = value instanceof URL ? value : new URL(value, window.location.href);
        return `${url.pathname}${url.search}${url.hash}`;
      } catch (error) {
        return "";
      }
    };

    const shouldIgnoreModifiedClick = event => {
      return event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    };

    const shouldIgnoreAnchor = anchor => {
      if (!anchor) return true;

      const rawHref = anchor.getAttribute("href");
      if (!rawHref || rawHref === "#" || rawHref === "null" || rawHref.startsWith("#")) return true;
      if (anchor.hasAttribute("download")) return true;
      if (anchor.target && anchor.target !== "_self") return true;

      return false;
    };

    const isSameOriginNavigableUrl = url => {
      if (url.origin !== window.location.origin) return false;

      // Keep actual exits as normal browser navigations.
      if (url.pathname === "/log-out" || url.pathname.startsWith("/log-out/")) return false;

      // These are the GHL shell routes used by the custom nav.
      return url.pathname.startsWith("/v2/location/") || url.pathname === "/billing" || url.pathname.startsWith("/billing/");
    };

    const getPossibleRouterFromValue = value => {
      if (!value) return null;

      if (value.push && typeof value.push === "function") return value;
      if (value.router && value.router.push && typeof value.router.push === "function") return value.router;
      if (value.$router && value.$router.push && typeof value.$router.push === "function") return value.$router;

      return null;
    };

    const findFrameworkRouter = () => {
      const directCandidates = [window.$router, window.router, window.app, window.App, window.$nuxt, window.__NUXT__, window.__app, window.__APP__];

      for (const candidate of directCandidates) {
        const router = getPossibleRouterFromValue(candidate);
        if (router) return router;
      }

      const roots = ["#app", "#__nuxt", ".lead-connector", "body"].map(selector => document.querySelector(selector)).filter(Boolean);

      const seen = new Set();
      let checked = 0;

      for (const root of roots) {
        const nodes = [root, ...root.querySelectorAll("*")];

        for (const node of nodes) {
          if (!node || seen.has(node)) continue;
          seen.add(node);
          checked += 1;

          // Keep this bounded so a click does not scan the whole app forever.
          if (checked > 800) return null;

          const candidates = [
            node.__vue__,
            node.__vue_app__ && node.__vue_app__.config && node.__vue_app__.config.globalProperties,
            node._vnode && node._vnode.ctx && node._vnode.ctx.appContext && node._vnode.ctx.appContext.config && node._vnode.ctx.appContext.config.globalProperties
          ];

          for (const candidate of candidates) {
            const router = getPossibleRouterFromValue(candidate);
            if (router) return router;
          }
        }
      }

      return null;
    };

    const dispatchRouteChangeEvents = url => {
      window.dispatchEvent(new CustomEvent("ghl-theme:navigate", { detail: { url: url.href } }));
      window.dispatchEvent(new PopStateEvent("popstate", { state: window.history.state }));
      window.dispatchEvent(new Event("locationchange"));

      // A lot of GHL layout pieces are measured after route transitions.
      window.setTimeout(() => window.dispatchEvent(new Event("resize")), 50);
    };

    const clickExistingNativeLink = (url, clickedAnchor) => {
      const targetPath = normalizeUrlPath(url);
      if (!targetPath) return false;

      const matchingLinks = Array.from(document.querySelectorAll("a[href]")).filter(link => {
        if (link === clickedAnchor) return false;
        if (link.matches(CUSTOM_NAV_SELECTOR)) return false;
        if (link.closest(".custom-nav-wrapper")) return false;
        if (link.closest(".hl_nav-header nav")) return false;
        if (shouldIgnoreAnchor(link)) return false;

        return normalizeUrlPath(link.href) === targetPath;
      });

      const nativeLink = matchingLinks[0];
      if (!nativeLink) return false;

      nativeLink.click();
      return true;
    };

    const routerPush = (router, url) => {
      const target = normalizeUrlPath(url);
      if (!target || !router || typeof router.push !== "function") return false;

      try {
        const result = router.push(target);
        if (result && typeof result.catch === "function") {
          result.catch(error => {
            // Ignore duplicated navigation errors; log actual failures so this can be debugged.
            const message = error && error.message ? error.message : "";
            if (!/duplicated|redundant|same route/i.test(message)) {
              console.warn("[GHL Build] SPA router navigation failed", error);
            }
          });
        }
        return true;
      } catch (error) {
        console.warn("[GHL Build] SPA router navigation failed", error);
        return false;
      }
    };

    const pushStateFallback = url => {
      const target = normalizeUrlPath(url);
      if (!target) return false;

      window.history.pushState({}, "", target);
      dispatchRouteChangeEvents(url);
      return true;
    };

const navigateToGhlRoute = (href, clickedAnchor) => {
  const url = new URL(href, window.location.href);
  if (!isSameOriginNavigableUrl(url)) return false;

  const targetPath = normalizeUrlPath(url);
  if (!targetPath || targetPath === normalizeUrlPath(window.location.href)) {
    return true;
  }

  const agentReportPath = `/v2/location/${locId}/reporting/agent`;
  const isAgentReport = url.pathname.replace(/\/+$/, "") === agentReportPath;

  if (isAgentReport && clickExistingNativeLink(url, clickedAnchor)) {
    return true;
  }

  const router = findFrameworkRouter();

  if (routerPush(router, url)) return true;
  if (clickExistingNativeLink(url, clickedAnchor)) return true;
  if (pushStateFallback(url)) return true;

  return false;
};

    document.addEventListener(
      "click",
      event => {
        const anchor = event.target && event.target.closest ? event.target.closest(CUSTOM_NAV_SELECTOR) : null;
        if (!anchor) return;
        if (shouldIgnoreModifiedClick(event) || shouldIgnoreAnchor(anchor)) return;

        const rawHref = anchor.getAttribute("href");
        let url;

        try {
          url = new URL(rawHref, window.location.href);
        } catch (error) {
          return;
        }

        if (!isSameOriginNavigableUrl(url)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const navigated = navigateToGhlRoute(url.href, anchor);
        if (!navigated) {
          window.location.assign(url.href);
        }
      },
      true
    );

    window.GHLTheme = window.GHLTheme || {};
    window.GHLTheme.navigate = href => navigateToGhlRoute(href, null);
  }

  installGhlSpaNavigationBridge();

  if (!window.location.pathname.includes("/settings")) {
    function getCurrentTopMenu(header) {
      const topMenus = Array.from(document.querySelectorAll("div.topmenu-nav"));

      if (window.location.pathname.includes("/tasks")) {
        return topMenus.find(topMenu => !header.contains(topMenu)) || topMenus[0];
      }

      return topMenus[0];
    }

    function moveCurrentTopMenu(leftDiv, topMenu) {
      if (!leftDiv || !topMenu) return;

      if (window.location.pathname.includes("/tasks")) {
        leftDiv.querySelectorAll(":scope > .topmenu-nav").forEach(currentTopMenu => {
          if (currentTopMenu !== topMenu) currentTopMenu.remove();
        });
      }

      if (!leftDiv.contains(topMenu)) {
        leftDiv.appendChild(topMenu);
      }
    }

    function moveHeaderElements() {
      if (
        window.location.pathname.includes("/dashboard") &&
        !window.location.pathname.includes("membership") &&
        !window.location.pathname.includes("wordpress") &&
        !window.location.pathname.includes("funnel")
      ) {
        return;
      }

      if (window.location.pathname.includes("settings")) {
        return;
      }

      const header = document.querySelector("header.hl_header");
      const topMenu = header && getCurrentTopMenu(header);

      if (!header || !topMenu) {
        return;
      }

      let wrapper = header.querySelector(".hl-top-wrapper");

      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.className = "hl-top-wrapper";

        const leftDiv = document.createElement("div");
        leftDiv.className = "hl-top-left";

        const rightDiv = document.createElement("div");
        rightDiv.className = "hl-top-right";

        while (header.firstChild) {
          rightDiv.appendChild(header.firstChild);
        }

        wrapper.appendChild(leftDiv);
        wrapper.appendChild(rightDiv);
        header.appendChild(wrapper);
      }

      const leftDiv = wrapper.querySelector(".hl-top-left");
      moveCurrentTopMenu(leftDiv, topMenu);
    }

    setInterval(moveHeaderElements, 300);

    function toggleDashboardBodyClass() {
      const body = document.body;

      if (
        window.location.pathname.includes("/dashboard") &&
        !window.location.pathname.includes("membership") &&
        !window.location.pathname.includes("wordpress") &&
        !window.location.pathname.includes("funnel")
      ) {
        body.classList.add("main-dashboard");
      } else {
        body.classList.remove("main-dashboard");
      }
    }

    setInterval(toggleDashboardBodyClass, 300);

    function updateHeaderLayout() {
      const body = document.body;

      if (
        window.location.pathname.includes("/dashboard") &&
        !window.location.pathname.includes("membership") &&
        !window.location.pathname.includes("wordpress") &&
        !window.location.pathname.includes("funnel")
      ) {
        body.classList.add("main-dashboard");
        return;
      } else {
        body.classList.remove("main-dashboard");
      }

      if (window.location.pathname.includes("settings")) {
        return;
      }

      const header = document.querySelector("header.hl_header");
      const topMenu = header && getCurrentTopMenu(header);

      if (!header || !topMenu) return;

      let wrapper = header.querySelector(".hl-top-wrapper");
      let leftDiv;

      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.className = "hl-top-wrapper";
        leftDiv = document.createElement("div");
        leftDiv.className = "hl-top-left";
        const rightDiv = document.createElement("div");
        rightDiv.className = "hl-top-right";
        while (header.firstChild) {
          rightDiv.appendChild(header.firstChild);
        }
        wrapper.appendChild(leftDiv);
        wrapper.appendChild(rightDiv);
        header.appendChild(wrapper);
      }

      leftDiv = header.querySelector(".hl-top-left");
      moveCurrentTopMenu(leftDiv, topMenu);

      let iconContainer = document.getElementById("hl-active-icon-container");
      if (!iconContainer) {
        iconContainer = document.createElement("div");
        iconContainer.id = "hl-active-icon-container";
        wrapper.insertBefore(iconContainer, leftDiv);
      }

      const activeSubLink = document.querySelector(".side-bar-custom-link.active-sub-link");
      const activeCategoryLink = document.querySelector(".side-bar-custom-link.background-highlight");

      const targetLink = activeSubLink || activeCategoryLink;

      let foundSVG = null;
      if (targetLink) {
        foundSVG = targetLink.querySelector("svg");
      }

      const newIconKey = foundSVG ? "svg-" + targetLink.getAttribute("href") : "none";

      if (iconContainer.dataset.currentIconKey !== newIconKey) {
        iconContainer.innerHTML = "";
        if (foundSVG) {
          const iconWrapper = document.createElement("div");
          iconWrapper.className = "icon-custom-header-wrapper";

          const clonedSVG = foundSVG.cloneNode(true);

          const paths = clonedSVG.querySelectorAll("path");
          paths.forEach(path => {
            if (path.getAttribute("stroke") && path.getAttribute("stroke").startsWith("url")) {
              path.setAttribute("stroke", "#707073");
            }
            if (path.getAttribute("fill") && path.getAttribute("fill").startsWith("url")) {
              path.setAttribute("fill", "#707073");
            }
          });

          iconWrapper.appendChild(clonedSVG);
          iconContainer.appendChild(iconWrapper);
        }
        if (window.location.pathname.includes("/tasks")) {
          iconContainer.removeAttribute("data-current-icon-key");
        } else {
          iconContainer.dataset.currentIconKey = newIconKey;
        }
      }
    }

    // setInterval(updateHeaderLayout, 300);

    let cmsDomain = "https://platform.growthstack.app";

    const SIDEBAR_CONFIGS = {
      dashboard: {
        className: "dashboard-sidebar",
        links: (isPayments, isInsights) => [
          {
            text: "Dashboard",
            icon: ICONS.DASHBOARD,
            class: !isPayments && !isInsights ? "background-highlight" : "",
            href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/dashboard/`
          },
          { text: "My Leads", icon: ICONS.INBOX, href: loc => `/v2/location/${loc}/opportunities` },
          { text: "Marketing", icon: ICONS.MARKETING, href: loc => `/v2/location/${loc}/marketing/emails/statistics` },
          { text: "My Website", icon: ICONS.MY_WEBSITE, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/my-website/` },
          { text: "Payments", icon: ICONS.PAYMENTS, class: isPayments ? "background-highlight" : "", href: loc => `/v2/location/${loc}/payments/invoices` },
          { text: "Insights", icon: ICONS.INSIGHTS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/` },
          { text: "Support", icon: ICONS.SUPPORT, href: () => `${cmsDomain}/support` },
          { text: "Settings", icon: ICONS.SETTINGS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/settings` }
        ]
      },
      myInbox: {
        className: "my-inbox-sidebar",
        links: () => [
          { text: "Dashboard", icon: ICONS.DASHBOARD, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/dashboard/` },
          { type: "divider" },
          { text: "My Leads", icon: ICONS.INBOX, class: "background-highlight", href: () => null },
          { type: "search" },
          { text: "Leads", icon: ICONS.LEADS, isSubItem: true, href: loc => `/v2/location/${loc}/opportunities` },
          { text: "Lead Overview", icon: ICONS.LEAD_OVERVIEW, isSubItem: true, href: loc => `/v2/location/${loc}/dashboard` },
          { text: "Conversations", icon: ICONS.CONVERSATIONS, isSubItem: true, counter: true, href: loc => `/v2/location/${loc}/conversations/conversations` },
          { text: "Appointments", icon: ICONS.APPOINTMENTS, isSubItem: true, href: loc => `/v2/location/${loc}/calendars/view` },
          { text: "Contacts", icon: ICONS.CONTACTS, isSubItem: true, href: loc => `/v2/location/${loc}/contacts/smart_list/All` },
          { text: "Reminders", icon: ICONS.REMINDERS, isSubItem: true, href: loc => `/v2/location/${loc}/tasks` },
          { type: "divider" },
          { text: "Marketing", icon: ICONS.MARKETING, href: loc => `/v2/location/${loc}/marketing/emails/statistics` },
          { text: "My Website", icon: ICONS.MY_WEBSITE, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/my-website/` },
          { text: "Payments", icon: ICONS.PAYMENTS, href: loc => `/v2/location/${loc}/payments/invoices` },
          { text: "Insights", icon: ICONS.INSIGHTS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/` },
          { text: "Support", icon: ICONS.SUPPORT, href: () => `${cmsDomain}/support` },
          { text: "Settings", icon: ICONS.SETTINGS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/settings` }
        ]
      },
      marketing: {
        className: "marketing-sidebar",
        links: () => [
          { text: "Dashboard", icon: ICONS.DASHBOARD, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/dashboard/` },
          { text: "My Leads", icon: ICONS.INBOX, href: loc => `/v2/location/${loc}/opportunities`, counter: true },
          { type: "divider" },
          { text: "Marketing", icon: ICONS.MARKETING, class: "background-highlight", href: () => null },
          { text: "SMS Templates", icon: ICONS.SMS_BLASTS, isSubItem: true, href: loc => `/v2/location/${loc}/marketing/templates` },
          { text: "Email Blasts", icon: ICONS.EMAIL_BLASTS, isSubItem: true, href: loc => `/v2/location/${loc}/marketing/emails/statistics` },
          { text: "Automations", icon: ICONS.AUTOMATIONS, isSubItem: true, href: loc => `/v2/location/${loc}/automation/workflows` },
          { text: "Social Media", icon: ICONS.SOCIAL_MEDIA, isSubItem: true, href: loc => `/v2/location/${loc}/marketing/social-planner` },
          { text: "QR Codes", icon: ICONS.QR_CODE, isSubItem: true, href: loc => `/v2/location/${loc}/qr-codes` },
          { text: "Chat Widgets", icon: ICONS.CHAT_WIDGET, isSubItem: true, href: loc => `/v2/location/${loc}/funnels-websites/chat-widget` },
          { text: "Reputation", icon: ICONS.REPUTATION, isSubItem: true, href: loc => `/v2/location/${loc}/reputation/overview` },
          { text: "Send a Blast", icon: ICONS.SEND_BLAST, isSubItem: true, href: loc => `/v2/location/${loc}/contacts/smart_list/All` },
          { type: "divider" },
          { text: "My Website", icon: ICONS.MY_WEBSITE, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/my-website/` },
          { text: "Payments", icon: ICONS.PAYMENTS, href: loc => `/v2/location/${loc}/payments/invoices` },
          { text: "Insights", icon: ICONS.INSIGHTS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/` },
          { text: "Support", icon: ICONS.SUPPORT, href: () => `#` },
          { text: "Settings", icon: ICONS.SETTINGS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/settings` }
        ]
      },
      insights: {
        className: "insights-sidebar",
        links: () => [
          { text: "Dashboard", icon: ICONS.DASHBOARD, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/dashboard/` },
          { text: "My Leads", icon: ICONS.INBOX, href: loc => `/v2/location/${loc}/conversations/conversations`, counter: true },
          { text: "Marketing", icon: ICONS.MARKETING, href: loc => `/v2/location/${loc}/marketing/emails/statistics` },
          { text: "My Website", icon: ICONS.MY_WEBSITE, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/my-website/` },
          { text: "Payments", icon: ICONS.PAYMENTS, href: loc => `/v2/location/${loc}/payments/invoices` },
          { type: "divider" },
          ...(tier === "SUBSCRIPTION"
            ? [
                { text: "Insights", icon: ICONS.INSIGHTS, class: "background-highlight", href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/` },
                { text: "Traffic", icon: ICONS.TRAFFIC, isSubItem: true, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/view/&scroll=traffic` },
                { text: "Leads", icon: ICONS.LEADS_INSIGHT, isSubItem: true, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/view/&scroll=leads/` },
                { text: "Visibility", icon: ICONS.VISIBILITY, isSubItem: true, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/view/&scroll=visibility/` },
                { text: "Digital Ads", icon: ICONS.DIGITAL_ADS, isSubItem: true, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/view/&scroll=digital-ads/` }
              ]
            : [
                { text: "Insights", icon: ICONS.INSIGHTS, class: "background-highlight", href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/` },
                { text: "Reporting", icon: ICONS.APPOINTMENTS, isSubItem: true, href: loc => `${cmsDomain}/my-profile/agency-analytics-login` }
              ]),
          { text: "Call Report", icon: ICONS.CALL_REPORT, isSubItem: true, href: loc => `/v2/location/${loc}/reporting/call` },
          { text: "Appt. Report", icon: ICONS.APPOINTMENTS, isSubItem: true, href: loc => `/v2/location/${loc}/reporting/appointment` },
          { type: "divider" },
          { text: "Support", icon: ICONS.SUPPORT, href: () => `#` },
          { text: "Settings", icon: ICONS.SETTINGS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/settings` }
        ]
      },
      settings: {
        className: "settings-sidebar",
        links: () => [
          { text: "Dashboard", icon: ICONS.DASHBOARD, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/dashboard/` },
          { text: "My Leads", icon: ICONS.INBOX, href: loc => `/v2/location/${loc}/conversations/conversations`, counter: true },
          { text: "Marketing", icon: ICONS.MARKETING, href: loc => `/v2/location/${loc}/marketing/emails/statistics` },
          { text: "My Website", icon: ICONS.MY_WEBSITE, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/my-website/` },
          { text: "Payments", icon: ICONS.PAYMENTS, href: loc => `/v2/location/${loc}/payments/invoices` },
          { text: "Insights", icon: ICONS.INSIGHTS, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/insights/` },
          { text: "Support", icon: ICONS.SUPPORT, href: () => `#` },
          { type: "divider" },
          { text: "Settings", icon: ICONS.SETTINGS, class: "background-highlight", href: () => `${cmsDomain}/site/ghl-route/${loc}?path=/settings` },
          { text: "Practice Info", icon: ICONS.BUSINESS_INFO, isSubItem: true, href: loc => `${cmsDomain}/site/ghl-route/${loc}?path=/site/business-info/` },
          { text: "Billing", icon: ICONS.BILLING, isSubItem: true, href: loc => `/billing` },
          { text: "Calendar Settings", icon: ICONS.CALENDAR_SETTINGS, isSubItem: true, href: loc => `/v2/location/${loc}/settings/calendars` },
          { text: "CRM Settings", icon: ICONS.CRM_SETTINGS, isSubItem: true, target: "_blank", href: loc => `/v2/location/${loc}/settings/company` },
          { text: "My Profile", icon: ICONS.MY_PROFILE, isSubItem: true, href: loc => `/v2/location/${loc}/settings/profile` },
          { text: "Log Out", icon: ICONS.LOG_OUT, isSubItem: true, href: () => `/log-out` }
        ]
      }
    };

    const generateSidebarHTML = (configKey, locationId, isPayments, isInsights) => {
      const config = SIDEBAR_CONFIGS[configKey];
      const links = typeof config.links === "function" ? config.links(isPayments, isInsights) : config.links;

      const normalizeHrefForActiveState = href => {
        if (!href || href === "#" || href === "null") return "";

        try {
          const url = new URL(href, window.location.href);

          // Your CMS proxy links look like:
          // https://platform.growthstack.app/site/ghl-route/:loc?path=/site/dashboard/
          // For active matching, compare against the inner path.
          const proxiedPath = url.searchParams.get("path");
          if (proxiedPath) {
            return proxiedPath.replace(/\/+$/, "");
          }

          return url.pathname.replace(/\/+$/, "");
        } catch (error) {
          return String(href).replace(/\/+$/, "");
        }
      };

      let topLinks = [];
      let otherLinks = [];
      let foundFirstDivider = false;

      links.forEach((link, index) => {
        const isSubItem = link.isSubItem;
        const nextLink = links[index + 1];
        const isLastSubItem = isSubItem && (!nextLink || !nextLink.isSubItem);
        const isVeryLastLink = index === links.length - 1;

        const linkHref = link.href ? link.href(locationId) : "#";
        const safeHref = linkHref || "#";
        const currentPathForActiveState = window.location.pathname.replace(/\/+$/, "");
        const currentSearchForActiveState = window.location.search || "";
        const normalizedHrefForActiveState = normalizeHrefForActiveState(safeHref);

        const isCurrentPage =
          normalizedHrefForActiveState &&
          normalizedHrefForActiveState !== "#" &&
          (currentPathForActiveState === normalizedHrefForActiveState ||
            currentPathForActiveState.startsWith(`${normalizedHrefForActiveState}/`) ||
            `${currentPathForActiveState}${currentSearchForActiveState}`.startsWith(normalizedHrefForActiveState));

        const activeSubClass = isSubItem && isCurrentPage ? "active-sub-link" : "";

        const subClass = isSubItem ? "sub-nav-item" : "";
        const lastSubClass = isLastSubItem ? "last-sub-nav-item" : "";
        const veryLastClass = isVeryLastLink ? "last-sidebar-link" : "";
        const activeClass = link.class || "";
        const counterHtml = link.counter ? `<div id="unread_convo" class="unread-counter"></div>` : "";
        const marginClass = isSubItem ? "ml-7" : "ml-2";

        const targetAttr = link.target ? `target="${link.target}"` : "";
        const spaAttr = !link.target ? `data-ghl-spa-link="true"` : "";

        let linkHtml = "";
        if (link.type === "divider") {
          linkHtml = `<div class="side-bar-custom-link ${veryLastClass}  divider"><p class=""></p></div>`;
        } else if (link.type === "search") {
          linkHtml = `<div id="search-bar-inbox" class="${veryLastClass}"></div>`;
        } else {
          linkHtml = `<a href="${safeHref}" ${targetAttr} ${spaAttr} class="side-bar-custom-link ${subClass} ${lastSubClass} ${veryLastClass} ${activeClass} ${activeSubClass} w-full group px-3 flex items-center justify-start text-sm font-medium rounded-md py-2 opacity-70 hover:opacity-100">${link.icon || ""}<span class="hl_text-overflow sm:hidden md:hidden nav-title lg:block xl:block ${marginClass}">${link.text}</span>${counterHtml}</a>`;
        }

        if (!foundFirstDivider) {
          topLinks.push(linkHtml);
          if (link.type === "divider") {
            foundFirstDivider = true;
          }
        } else {
          otherLinks.push(linkHtml);
        }
      });

      const topLinksClass = configKey === "dashboard" ? "sidebar-top-links dashboard-sidebar-top-links" : "sidebar-top-links";
      const wrappedTop = `<div class="${topLinksClass}">${topLinks.join("")}</div>`;

      return `<nav class="flex-1 w-full ${config.className}" aria-label="header">${wrappedTop}${otherLinks.join("")}</nav>`;
    };

    (function () {
      let lastStateKey = "";
      setInterval(() => {
        const currentPath = window.location.pathname;
        const navHeader = document.querySelector(".lead-connector .hl_nav-header, .lead-connector .hl_nav-header-without-footer");

        if (navHeader) {
          const locationId = currentPath.split("/")[3];
          const isPayments = currentPath.includes("/payments/");
          const isInsights = currentPath.includes("/reporting") || currentPath.includes("/agency-analytics-login");
          const isDashboard = currentPath.includes("/dashboard");
          const isSettings = currentPath.includes("/settings/") || currentPath.includes("/crm-settings");
          const isMarketing =
            currentPath.includes("/marketing/") || currentPath.includes("/automation/") || currentPath.includes("/qr-codes") || currentPath.includes("/chat-widget");
          const isInbox = ["/opportunities/", "/conversations/", "/calendars/", "/contacts/", "/reputation/"].some(p => currentPath.includes(p)) || isDashboard;

          let currentView = "myInbox";
          if (isPayments) currentView = "dashboard";
          else if (isSettings) currentView = "settings";
          else if (isInsights) currentView = "insights";
          else if (isMarketing) currentView = "marketing";
          else if (isInbox) currentView = "myInbox";

          const svgAssetsVersion = window.__ghlSvgAssetsReadyVersion || 0;
          const stateKey = [currentView, currentPath, window.location.search, isPayments, isInsights, svgAssetsVersion].join("-");

          if (stateKey !== lastStateKey || !navHeader.querySelector(".side-bar-custom-link")) {
            lastStateKey = stateKey;
            navHeader.innerHTML = generateSidebarHTML(currentView, locationId, isPayments, isInsights);
          }

          const searchInput = document.getElementById("globalSearchOpener");
          const targetId = document.getElementById("search-bar-inbox");
          if (searchInput && targetId && !targetId.contains(searchInput)) {
            targetId.appendChild(searchInput);
          }
        }
      }, 300);
    })();

    setInterval(() => {
      document.querySelectorAll(".lead-connector a.active").forEach(el => el.classList.remove("active"));
    }, 300);

    const sidebarStateMonitor = new MutationObserver(changes => {
      changes.forEach(change => {
        if (change.attributeName === "class") {
          const sidebarContainer = document.querySelector(".sidebar-v2-location");
          const searchComponent = document.querySelector(".search-dropdown-sidebar");

          if (sidebarContainer && searchComponent) {
            if (sidebarContainer.classList.contains("v2-collapse")) {
              searchComponent.style.setProperty("display", "none", "important");
            } else {
              searchComponent.style.removeProperty("display");
            }
          }
        }
      });
    });

    const sidebarWrapper = document.querySelector(".sidebar-v2-location");
    if (sidebarWrapper) {
      sidebarStateMonitor.observe(sidebarWrapper, { attributes: true });

      if (sidebarWrapper.classList.contains("v2-collapse")) {
        const searchComponent = document.querySelector(".search-dropdown-sidebar");
        if (searchComponent) searchComponent.style.setProperty("display", "none", "important");
      }
    }

    const searchWatcher = new MutationObserver(() => {
      const parent = document.getElementById("globalSearchOpener");
      if (parent) {
        const el = parent.querySelector(".search-placeholder");
        if (el && el.innerHTML !== "Search") {
          searchWatcher.disconnect();
          el.innerHTML = "Search";
          startWatching();
        }
      }
    });

    function startWatching() {
      const parent = document.getElementById("globalSearchOpener");
      if (parent) {
        const el = parent.querySelector(".search-placeholder");
        if (el) {
          searchWatcher.observe(el, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }

    startWatching();

    setInterval(() => {
      const isConvPage = window.location.href.includes("/conversations/conversations/");
      const bodyClass = document.body.classList;

      if (isConvPage && !bodyClass.contains("conversation-page")) {
        bodyClass.add("conversation-page");
      } else if (!isConvPage && bodyClass.contains("conversation-page")) {
        bodyClass.remove("conversation-page");
      }
    }, 1000);

    const initScript = () => {
      let lastActiveText = null;
      let lastActiveIcon = null;
      let lastMenuHtml = null;
      let domObserver;

      const getActiveSidebarData = () => {
        const activeLink = document.querySelector(
          ".hl_nav-header nav a.exact-active, .hl_nav-header nav a.active, .hl_nav-header .active-sub-link, .hl_nav-header .background-highlight, a.exact-active"
        );
        if (!activeLink) return { text: "Menu", icon: "" };
        const titleEl = activeLink.querySelector(".nav-title");
        const text = titleEl ? titleEl.innerText.trim() : "Menu";
        const iconEl = activeLink.querySelector("svg, img, i");
        const icon = iconEl ? iconEl.outerHTML : "";
        return { text, icon };
      };

const addAgentReportToReportingDropdown = dropdownContent => {
  if (!window.location.pathname.includes("/reporting")) return;

  if (dropdownContent.querySelector("#tb_agent-report")) return;

  const callReportLink = dropdownContent.querySelector(
    `:scope > a[href*="/reporting/call"]`
  );

  if (!callReportLink) return;

  const nativeAgentLink = Array.from(
    document.querySelectorAll("a[href]")
  ).find(link => {
    if (link.closest(".custom-nav-wrapper")) return false;

    const label = link.querySelector("span.flex.items-center");

    return (
      label &&
      label.textContent.trim().toLowerCase() === "agent report"
    );
  });

  const agentReportLink = callReportLink.cloneNode(true);

  const agentReportLabel = agentReportLink.querySelector(
    "span.flex.items-center"
  );

  if (!agentReportLabel) return;

  agentReportLink.id = "tb_agent-report";
  agentReportLabel.textContent = "Agent report";

  if (nativeAgentLink) {
    const realHref = nativeAgentLink.getAttribute("href");

    if (realHref) {
      agentReportLink.setAttribute("href", realHref);
    }

    agentReportLink.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      nativeAgentLink.click();
    });
  } else {
    const fallbackPath = `/v2/location/${locId}/reporting/agent`;

    agentReportLink.setAttribute("href", fallbackPath);

    agentReportLink.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (
        window.GHLTheme &&
        typeof window.GHLTheme.navigate === "function"
      ) {
        window.GHLTheme.navigate(fallbackPath);
      }
    });
  }

  callReportLink.insertAdjacentElement(
    "afterend",
    agentReportLink
  );
};

      const buildOrUpdateMenu = () => {
        const navContainer = document.querySelector(".hl-top-left .topmenu-nav");

        if (!navContainer) return;

        if (domObserver) domObserver.disconnect();

        if (!document.getElementById("custom-menu-styles")) {
          const style = document.createElement("style");
          style.id = "custom-menu-styles";
          style.innerHTML = `
		.hl-top-left .topmenu-nav > .topmenu-navitem:not(.custom-nav-wrapper) { display: none !important; }
		.hl-top-left .topmenu-nav > .topmenu-navtitle { display: none !important; }
		.custom-nav-wrapper { display: flex; align-items: center; gap: 8px; position: relative; }
		.custom-menu-btn { display: flex; align-items: center; gap: 8px; background: transparent; border: none; color: white; font-weight: 700; font-size: 15px; cursor: pointer; padding: 0; }
		.custom-icon-wrapper { position: relative; display: flex; align-items: center; cursor: pointer; }
		
		.custom-icon-wrapper .custom-dropdown-content { 
				position: absolute !important;
				top: 0px !important; 
				left: 35px !important; 
				visibility: hidden; 
				opacity: 0; 
				pointer-events: none; 
				z-index: 9999; 
				background-color: white !important;
				box-shadow: 0 30px 40px 0 rgba(0, 0, 0, 0.07), 0 21.78px 33.422px 0 rgba(0, 0, 0, 0.04), 0 6.65px 5.32px 0 rgba(0, 0, 0, 0.03), 0 2.767px 2.214px 0 rgba(0, 0, 0, 0.02);
				border-radius: 15px; 
				padding: 8px 0; 
				min-width: 220px; 
				width: max-content; 
				border: 1px solid #e5e7eb;
				
				transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out, visibility 0.2s linear;
		}

		.custom-icon-wrapper:hover .custom-dropdown-content { 
				visibility: visible !important; 
				opacity: 1 !important; 
				pointer-events: auto !important; 
				transform: translateY(0);
				transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out, visibility 0s linear;
		}
		
		.custom-dropdown-item { 
				display: flex !important; 
				flex-direction: column !important; 
				align-items: flex-start !important; 
				padding: 0 !important; 
				color: #4b5563 !important; 
				text-decoration: none !important; 
				font-size: 14px !important; 
				font-weight: 500 !important; 
				line-height: 1 !important;
				position: relative !important; 
				cursor: pointer; 
		}

		.custom-dropdown-item > span.flex { width: 100%; display: flex; align-items: center; justify-content: flex-start; padding: 8px 10px !important; gap: 8px; line-height: 1 !important; }
		.custom-dropdown-item > span.flex i.fa-angle-down { margin-left: auto !important; }
		
		.custom-nested-menu { 
				display: none !important; 
				position: absolute !important; 
				left: 100% !important; 
				top: 0 !important;
				background-color: white !important;
				box-shadow: 0 30px 40px 0 rgba(0, 0, 0, 0.07) !important;
				border-radius: 15px !important; 
				padding: 8px 0 !important; 
				min-width: 200px; 
				z-index: 10000 !important; 
				border: 1px solid #e5e7eb;
		}

		.custom-dropdown-item:hover > .custom-nested-menu { display: block !important; }
		.custom-nested-menu a { display: flex !important; align-items: center; padding: 8px 16px !important; color: #4b5563 !important; text-decoration: none !important; font-size: 14px !important; font-weight: 500 !important; line-height: 1 !important; }
		
		#hl-active-icon-container { display: flex; align-items: center; justify-content: center; margin-right: 8px; }
		#hl-active-icon-container svg, #hl-active-icon-container img, #hl-active-icon-container i { width: 18px !important; height: 17px !important; display: block !important; }
`;
          document.head.appendChild(style);
        }

        let wrapper = navContainer.querySelector(".custom-nav-wrapper");
        if (!wrapper) {
          wrapper = document.createElement("div");
          wrapper.className = "custom-nav-wrapper";
          wrapper.innerHTML = `
				<button class="custom-menu-btn"><span class="custom-menu-text"></span></button>
				<div class="custom-icon-wrapper">
					<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.25153 12.0784C9.22552 11.4373 10.0199 10.6963 10.7015 9.78847C10.8876 9.5407 10.9806 9.41682 10.9806 9.25C10.9806 9.08318 10.8876 8.9593 10.7015 8.71154C10.0199 7.80367 9.22552 7.06266 8.25153 6.42157M9.75 17.75L8.75 17.75C4.97876 17.75 3.09315 17.75 1.92157 16.5784C0.75 15.4069 0.75 13.5212 0.75 9.75L0.75 8.75C0.75 4.97876 0.749999 3.09314 1.92157 1.92157C3.09315 0.749996 4.97876 0.749996 8.75 0.749997L9.75 0.749997C13.5212 0.749997 15.4069 0.749997 16.5784 1.92157C17.75 3.09314 17.75 4.97876 17.75 8.75L17.75 9.75C17.75 13.5212 17.75 15.4069 16.5784 16.5784C15.4069 17.75 13.5212 17.75 9.75 17.75Z" stroke="#CFCFD6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
					<div class="custom-dropdown-content"></div>
				</div>`;
          navContainer.appendChild(wrapper);
        }

        const data = getActiveSidebarData();

        const textSpan = wrapper.querySelector(".custom-menu-text");
        if (textSpan && data.text !== lastActiveText) {
          textSpan.innerText = data.text;
          lastActiveText = data.text;
        }
        const activeIconContainer = document.getElementById("hl-active-icon-container");

        if (activeIconContainer && data.icon && data.icon !== lastActiveIcon) {
          activeIconContainer.innerHTML = data.icon;
          lastActiveIcon = data.icon;
        }

        const originalLinks = Array.from(navContainer.children).filter(
  el =>
    (el.classList.contains("topmenu-navitem") || el.tagName === "A") &&
    !el.classList.contains("custom-nav-wrapper")
);

        if (originalLinks.length > 0) {
          const currentMenuHtml = originalLinks.map(link => link.outerHTML).join("");

          if (currentMenuHtml !== lastMenuHtml) {
            const dropdownContent = wrapper.querySelector(".custom-dropdown-content");
            dropdownContent.innerHTML = "";

            originalLinks.forEach(link => {
              const clone = link.cloneNode(true);
              clone.className = "custom-dropdown-item";

              if (clone.id === "tb_conversations-tab" && window.location.href.includes("conversations/conversations")) {
                clone.setAttribute("aria-current", "page");
              }

              const nestedMenus = clone.querySelectorAll('[role="menu"], .dropdown-content');
              nestedMenus.forEach(menu => {
                if (menu.querySelectorAll("a").length === 0) {
                  menu.remove();
                } else {
                  menu.className = "custom-nested-menu";
                }
              });
              dropdownContent.appendChild(clone);
            });
            addAgentReportToReportingDropdown(dropdownContent);

            lastMenuHtml = currentMenuHtml;
          }
        }

        if (domObserver) domObserver.observe(document.body, { childList: true, subtree: true });
      };

      let debounceTimer;
      const requestUpdate = () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(buildOrUpdateMenu, 150);
      };

      domObserver = new MutationObserver(() => requestUpdate());
      domObserver.observe(document.body, { childList: true, subtree: true });

      window.addEventListener("popstate", requestUpdate);
      const patchState = type => {
        const orig = history[type];
        history[type] = function () {
          const res = orig.apply(this, arguments);
          requestUpdate();
          return res;
        };
      };
      patchState("pushState");
      patchState("replaceState");

      requestUpdate();
    };

    initScript();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initScript);
    } else {
      initScript();
    }

    const titleTagMutationObserver = new MutationObserver(() => {
      const url = window.location.href;
      const locElement = document.querySelector("#location-switcher-sidbar-v2 .hl_switcher-loc-name");

      if (locElement && locElement.innerText.trim() !== "") {
        const locationName = locElement.innerText.trim();
        const suffix = ` | ${locationName}`;

        const pages = {
          "/dashboard": "Leads Dashboard",
          "/conversations/": "Conversations",
          "/my-website/": "My Website",
          "/marketing/": "Marketing",
          "/payments/": "Payments",
          "/agency-analytics-login": "Insights",
          "/opportunities": "Opportunities",
          "/calendars/": "Calendars",
          "/contacts/": "Contacts",
          "/tasks": "Tasks",
          "/reputation/": "Reputation",
          "/automation/": "Automation",
          "/social-planner": "Social Planner",
          "/billing": "Billing",
          "/business-info/": "Business Info",
          "/business": "Companies",
          "/survey": "Sites",
          "/settings": "Settings",
          "/wordpress": "Sites",
          "/reporting": "Reporting",
          "/analytics": "Analytics",
          "/memberships": "Memberships",
          "/funnels-websites": "Sites",
          "/ai-agents": "AI Agents"
        };

        for (const path in pages) {
          if (url.includes(path)) {
            const newTitle = pages[path] + suffix;
            if (document.title !== newTitle) {
              document.title = newTitle;
            }
            break;
          }
        }
      }
    });

    titleTagMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // setInterval(() => {
    //   if (window.location.href.includes("settings")) {
    //     document.body.classList.add("is-settings-page-custom");
    //   } else {
    //     document.body.classList.remove("is-settings-page-custom");
    //   }
    // }, 100);

    setTimeout(() => {
      const targetNav = document.querySelector(".hl_nav-header");
      const toggleContainer = document.querySelector("#sidebar-v2 .absolute.z-50.-right-2.bottom-5");

      if (targetNav && toggleContainer) {
        targetNav.style.position = "relative";
        targetNav.prepend(toggleContainer);

        toggleContainer.style.bottom = "auto";
        toggleContainer.style.top = "0";
        toggleContainer.style.right = "-12px";
      }
    }, 1000);

    const applySidebarWrapper = () => {
      if (!document.body.classList.contains("is-settings-page-custom")) return;

      const target = document.getElementById("location-switcher-sidbar-v2");
      if (target && !target.parentElement.classList.contains("search-dropdown-sidebar")) {
        const sibling = target.nextElementSibling;
        if (!sibling) return;

        const wrapper = document.createElement("div");
        wrapper.className = "search-dropdown-sidebar";

        target.parentNode.insertBefore(wrapper, target);
        wrapper.appendChild(target);
        wrapper.appendChild(sibling);
      }
    };

    const sidebarLayoutWatcher = new MutationObserver(() => {
      applySidebarWrapper();
    });

    sidebarLayoutWatcher.observe(document.body, {
      childList: true,
      subtree: true
    });

    applySidebarWrapper();
  }

  const ElementHider = new MutationObserver(() => {
    const target = document.querySelector("#sb_settings, .sb_settings");
    if (target) {
      target.style.setProperty("display", "none", "important");
    }
  });

  ElementHider.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  const nexusFlowObserver = new MutationObserver((mutations, obs) => {
    const targetBody = document.body;
    if (targetBody) {
      if (!targetBody.classList.contains("injected-custom-nav")) {
        targetBody.classList.add("injected-custom-nav");
      }
    }
  });

  nexusFlowObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.body) {
    document.body.classList.add("injected-custom-nav");
  }
})();

function installGhlRouterHeaderNameFix() {
  if (window.__ghlRouterHeaderNameFixInstalled) return;
  window.__ghlRouterHeaderNameFixInstalled = true;

  let lastHeaderName = "";
  let lastPath = "";
  let rafId = null;
  let isApplying = false;

  const getPossibleRouterFromValue = value => {
    if (!value) return null;

    if (value.afterEach && typeof value.afterEach === "function") return value;
    if (value.router && value.router.afterEach && typeof value.router.afterEach === "function") return value.router;
    if (value.$router && value.$router.afterEach && typeof value.$router.afterEach === "function") return value.$router;

    return null;
  };

  const findFrameworkRouter = () => {
    const directCandidates = [window.$router, window.router, window.app, window.App, window.$nuxt, window.__NUXT__, window.__app, window.__APP__];

    for (const candidate of directCandidates) {
      const router = getPossibleRouterFromValue(candidate);
      if (router) return router;
    }

    const roots = ["#app", "#__nuxt", ".lead-connector", "body"].map(selector => document.querySelector(selector)).filter(Boolean);

    const seen = new Set();
    let checked = 0;

    for (const root of roots) {
      const nodes = [root, ...root.querySelectorAll("*")];

      for (const node of nodes) {
        if (!node || seen.has(node)) continue;

        seen.add(node);
        checked += 1;

        if (checked > 800) return null;

        const candidates = [
          node.__vue__,
          node.__vue_app__ && node.__vue_app__.config && node.__vue_app__.config.globalProperties,
          node._vnode && node._vnode.ctx && node._vnode.ctx.appContext && node._vnode.ctx.appContext.config && node._vnode.ctx.appContext.config.globalProperties
        ];

        for (const candidate of candidates) {
          const router = getPossibleRouterFromValue(candidate);
          if (router) return router;
        }
      }
    }

    return null;
  };

  const normalizePath = href => {
    try {
      return new URL(href, window.location.origin).pathname;
    } catch {
      return "";
    }
  };

  const getNameFromSidebarRoute = () => {
    const currentPath = window.location.pathname;

    const links = Array.from(document.querySelectorAll(".my-inbox-sidebar .side-bar-custom-link.sub-nav-item[href]"));

    const exactMatch = links.find(link => {
      const linkPath = normalizePath(link.getAttribute("href"));
      return linkPath && currentPath === linkPath;
    });

    const partialMatch = links.find(link => {
      const linkPath = normalizePath(link.getAttribute("href"));
      return linkPath && currentPath.startsWith(linkPath + "/");
    });

    const matchedLink = exactMatch || partialMatch;
    const name = matchedLink?.querySelector(".nav-title")?.textContent?.trim();

    return name || "";
  };

  const getNameFromNativeHeader = () => {
    const name = document.querySelector(".hl-top-left .topmenu-navtitle")?.textContent?.trim();
    return name || "";
  };

  const getCorrectHeaderName = () => {
    const sidebarName = getNameFromSidebarRoute();
    if (sidebarName) return sidebarName;

    const nativeName = getNameFromNativeHeader();
    if (nativeName) return nativeName;

    return lastHeaderName;
  };

  const applyHeaderName = () => {
    const customMenuText = document.querySelector(".custom-menu-text");
    if (!customMenuText) return;

    const currentPath = window.location.pathname;
    const name = getCorrectHeaderName();

    if (!name) return;

    lastPath = currentPath;
    lastHeaderName = name;

    if (customMenuText.textContent.trim() === name) return;

    isApplying = true;
    customMenuText.textContent = name;

    requestAnimationFrame(() => {
      isApplying = false;
    });
  };

  const fixDirectIconSvg = () => {
    const iconContainer = document.getElementById("hl-active-icon-container");
    if (!iconContainer) return;

    const directSvg = iconContainer.querySelector(":scope > svg");
    if (!directSvg) return;

    directSvg.classList.add("icon-custom-header-wrapper");
  };

  const runFixes = () => {
    applyHeaderName();
    fixDirectIconSvg();
  };

  const scheduleRunFixes = () => {
    if (rafId) cancelAnimationFrame(rafId);

    rafId = requestAnimationFrame(() => {
      rafId = null;
      runFixes();
    });
  };

  const router = findFrameworkRouter();

  if (router && typeof router.afterEach === "function") {
    router.afterEach(() => {
      scheduleRunFixes();
    });
  }

  document.addEventListener(
    "click",
    event => {
      const link = event.target.closest ? event.target.closest(".my-inbox-sidebar .side-bar-custom-link.sub-nav-item[href]") : null;

      if (!link) return;

      const name = link.querySelector(".nav-title")?.textContent?.trim();

      if (name) {
        lastHeaderName = name;
        lastPath = normalizePath(link.getAttribute("href"));
      }

      scheduleRunFixes();
    },
    true
  );

  const installHeaderObserver = () => {
    const target = document.querySelector(".hl-top-left");
    if (!target || target.__ghlHeaderNameObserverInstalled) return;

    target.__ghlHeaderNameObserverInstalled = true;

    const observer = new MutationObserver(() => {
      if (isApplying) return;
      scheduleRunFixes();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  };

  const routerReadyObserver = new MutationObserver(() => {
    installHeaderObserver();
    scheduleRunFixes();
  });

  routerReadyObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  installHeaderObserver();
  scheduleRunFixes();
}

installGhlRouterHeaderNameFix();

// function fixTasksHeaderIconOnly() {
//   const iconContainer = document.getElementById("hl-active-icon-container");
//   if (!iconContainer) return;

//   const isTasksIcon = iconContainer.dataset.currentIconKey?.includes("/tasks");
//   if (!isTasksIcon) return;

//   const svg = iconContainer.querySelector(":scope > svg");
//   if (!svg) return;

//   svg.classList.remove("icon-custom-header-wrapper");
//   svg.style.removeProperty("filter");

//   svg.style.display = "block";
//   svg.style.opacity = "1";
//   svg.style.visibility = "visible";
//   svg.style.width = "17px";
//   svg.style.height = "18px";

//   svg.querySelectorAll("path").forEach(path => {
//     path.setAttribute("stroke", "#707073");
//   });
// }

// requestAnimationFrame(fixTasksHeaderIconOnly);

function installTasksHeaderIconPersistenceFix() {
  if (window.__tasksHeaderIconPersistenceFixInstalled) return;
  window.__tasksHeaderIconPersistenceFixInstalled = true;

  let savedTasksIconHTML = "";
  let rafId = null;
  let isRestoring = false;
  let observedContainer = null;
  let containerObserver = null;

  const isTasksIconContainer = iconContainer => {
    return iconContainer?.dataset?.currentIconKey?.includes("/tasks");
  };

  const saveTasksIcon = () => {
    const iconContainer = document.getElementById("hl-active-icon-container");
    if (!isTasksIconContainer(iconContainer)) return;

    const svg = iconContainer.querySelector("svg");
    if (!svg) return;

    savedTasksIconHTML = svg.outerHTML;
  };

  const restoreTasksIcon = () => {
    if (isRestoring) return;

    const iconContainer = document.getElementById("hl-active-icon-container");
    if (!isTasksIconContainer(iconContainer)) return;

    const svg = iconContainer.querySelector("svg");

    if (svg) {
      saveTasksIcon();
      return;
    }

    if (!savedTasksIconHTML) return;

    isRestoring = true;
    iconContainer.innerHTML = savedTasksIconHTML;

    requestAnimationFrame(() => {
      isRestoring = false;
    });
  };

  const run = () => {
    saveTasksIcon();
    restoreTasksIcon();
    watchCurrentIconContainer();
  };

  const scheduleRun = () => {
    if (rafId) cancelAnimationFrame(rafId);

    rafId = requestAnimationFrame(() => {
      rafId = null;
      run();
    });
  };

  const watchCurrentIconContainer = () => {
    const iconContainer = document.getElementById("hl-active-icon-container");
    if (!iconContainer || observedContainer === iconContainer) return;

    if (containerObserver) {
      containerObserver.disconnect();
    }

    observedContainer = iconContainer;

    containerObserver = new MutationObserver(() => {
      if (isRestoring) return;
      scheduleRun();
    });

    containerObserver.observe(iconContainer, {
      childList: true,
      subtree: false,
      attributes: true,
      attributeFilter: ["data-current-icon-key"]
    });
  };

  const getPossibleRouterFromValue = value => {
    if (!value) return null;

    if (value.afterEach && typeof value.afterEach === "function") return value;
    if (value.router?.afterEach && typeof value.router.afterEach === "function") return value.router;
    if (value.$router?.afterEach && typeof value.$router.afterEach === "function") return value.$router;

    return null;
  };

  const routerCandidates = [window.$router, window.router, window.app, window.App, window.$nuxt, window.__NUXT__, window.__app, window.__APP__];

  for (const candidate of routerCandidates) {
    const router = getPossibleRouterFromValue(candidate);

    if (router) {
      router.afterEach(scheduleRun);
      break;
    }
  }

  document.addEventListener(
    "click",
    event => {
      const link = event.target.closest ? event.target.closest('.my-inbox-sidebar .side-bar-custom-link.sub-nav-item[href*="/tasks"]') : null;

      if (!link) return;

      const svg = link.querySelector("svg");
      if (svg) {
        savedTasksIconHTML = svg.outerHTML;
      }

      scheduleRun();
    },
    true
  );

  const wrapperObserver = new MutationObserver(scheduleRun);

  const wrapperTarget = document.querySelector(".hl-top-wrapper") || document.documentElement;

  wrapperObserver.observe(wrapperTarget, {
    childList: true,
    subtree: true
  });

  scheduleRun();
}

installTasksHeaderIconPersistenceFix();

function installNoTasksIconKeyFix() {
  if (window.__noTasksIconKeyFixInstalled) return;
  window.__noTasksIconKeyFixInstalled = true;

  const cleanTasksIconKey = () => {
    if (!window.location.pathname.includes("/tasks")) return;

    const iconContainer = document.getElementById("hl-active-icon-container");
    if (!iconContainer) return;

    if (iconContainer.dataset.currentIconKey?.includes("/tasks")) {
      delete iconContainer.dataset.currentIconKey;
    }
  };

  const getPossibleRouterFromValue = value => {
    if (!value) return null;

    if (value.afterEach && typeof value.afterEach === "function") return value;
    if (value.router && value.router.afterEach && typeof value.router.afterEach === "function") return value.router;
    if (value.$router && value.$router.afterEach && typeof value.$router.afterEach === "function") return value.$router;

    return null;
  };

  const routerCandidates = [window.$router, window.router, window.app, window.App, window.$nuxt, window.__NUXT__, window.__app, window.__APP__];

  for (const candidate of routerCandidates) {
    const router = getPossibleRouterFromValue(candidate);

    if (router) {
      router.afterEach(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(cleanTasksIconKey);
        });
      });
      break;
    }
  }

  cleanTasksIconKey();
}

installNoTasksIconKeyFix();
